import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import SwipeableViews from 'react-swipeable-views';
import YourTrippins from './YourTrippins';
import TaggedTrippins from './TaggedTrippins';
import { Tabs, Tab } from "@mui/material";
import "../styles/trippinTabs.css"

function TrippinsTabs() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleSwipeChange = (index) => {
    setActiveTab(index);
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => setActiveTab((prev) => (prev < 1 ? prev + 1 : prev)),
    onSwipedRight: () => setActiveTab((prev) => (prev > 0 ? prev - 1 : prev)),
    trackMouse: true,
  });

  return (
    <div {...handlers} className="trippin-tabs-container">
      <Tabs 
        value={activeTab} 
        onChange={handleTabChange} 
        centered 
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "#2c3e50",
          },
          "& .MuiTab-root": {
            fontFamily: "'Poppins', sans-serif",
            color: "#555",
          },
          "& .MuiTab-root.Mui-selected": {
            color: "#2c3e50",
            fontWeight: "bold",
          },
        }}
      >
        <Tab label="My trippins" />
        <Tab label="Tagged trippins" />
      </Tabs>

      <SwipeableViews
        index={activeTab}
        onChangeIndex={handleSwipeChange}
        enableMouseEvents
      >
        <div>
          <YourTrippins />
        </div>
        <div>
          <TaggedTrippins />
        </div>
      </SwipeableViews>
    </div>
  );
}

export default TrippinsTabs;
